<template>
  <div>
    <v-card max-height="700">
      <v-card-title :style="backgroundStarStyle">
        <span class="headline black--text">Import/Export Json file</span>
        <v-spacer></v-spacer>
        <v-btn
          icon
          light
          class="m-0"
          v-on:click="closeImportExportJsonFileDialog()"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-select
        class="mr-3 mt-3 ml-3"
        label="Export/Import"
        v-model="selectedMode"
        :items="mode"
        width="300"
      >
      </v-select>
      <v-card-text v-if="selectedMode">
        <div v-if="selectedMode === 'Import'">
          <v-text-field
            label="Select..."
            v-model="fileName"
            prepend-icon="attach_file"
            v-on:click="openFileFinder()"
          ></v-text-field>
          <input
            ref="inputFile"
            type="file"
            accept="application/json"
            style="display: none"
            @change="getInputFile"
          />
          <v-row justify-end>
            <v-btn
              :disabled="isNoImportFile"
              color="primary"
              v-on:click="importItems()"
              >Import</v-btn
            >
          </v-row>
        </div>
        <div v-if="selectedMode === 'Export' && items">
          <v-list>
            <v-list-item v-for="item of items" :key="item.id">
              <v-list-item-content>{{ item.name }}</v-list-item-content>
              <v-list-item-action>
                <v-checkbox
                  v-model="checkedItems"
                  :value="item.id"
                ></v-checkbox>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-row justify-end>
            <v-btn
              :disabled="isNoExportItems"
              class="mr-5 ml-3"
              color="primary"
              v-on:click="exportSelectedItems()"
              >Export</v-btn
            >
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'import-export-json-file',
  props: {
    root: Object
  },

  mounted() {
    this.$http.get(this.root.root.getCurrentAPI()).then((response) => {
      this.items = response.data
    })
  },

  watch: {
    isDisplayed(value) {
      if (value === true) {
        this.$http.get(this.root.root.getCurrentAPI()).then((response) => {
          this.items = response.data
        })
      }
    }
  },

  data() {
    return {
      fileName: '',
      selectedMode: '',
      mode: ['Import', 'Export'],
      items: null,
      checkedItems: [],
      file: null
    }
  },

  computed: {
    backgroundStarStyle() {
      return (
        'background: #3BE287'
      )
    },
    isNoExportItems() {
      if (this.checkedItems.length) {
        return false
      } else {
        return true
      }
    },
    isNoImportFile() {
      if (this.fileName.length) {
        return false
      } else {
        return true
      }
    },
    isDisplayed() {
      return this.root.importExportJsonFileDialog
    }
  },

  methods: {
    closeImportExportJsonFileDialog() {
      this.root.importExportJsonFileDialog = false
    },
    getInputFile(event) {
      const file = event.target.files[0]
      this.fileName = file.name
      this.file = file
    },
    openFileFinder() {
      this.$refs.inputFile.click()
    },
    downloadJsonFile(name, textContent, extension = 'json', utf8 = true) {
      const encodingCharacter = utf8 ? '\ufeff' : ''
      let blob = new Blob([encodingCharacter + textContent])
      let a = window.document.createElement('a')
      a.href = window.URL.createObjectURL(blob, { type: 'application/json' })
      a.download = name + '.' + extension
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    exportSelectedItems() {
      let selectedItems = []
      for (let item of this.items) {
        for (let selectedId of this.checkedItems) {
          if (item.id === selectedId) {
            selectedItems.push(item)
          }
        }
      }
      this.downloadJsonFile(
        this.root.root.getCurrentFormType(),
        JSON.stringify(
          {
            type: this.root.root.getCurrentFormType(),
            version: 'TODO',
            items: selectedItems
          },
          null,
          2
        )
      ) // TODO get Form Version
      this.closeImportExportJsonFileDialog()
    },
    sendCustomNotification(title, text) {
      this.root.root.$notify({
        group: 'notifications',
        type: 'error',
        duration: -1,
        title: title + ' - Click to dismiss',
        text: text
      })
    },
    async formatDataToImport(data) {
      let indexOfParentObject = 1
      for (let item of data.items) {
        item.id = ''
        if (
          !item.name ||
          !item.typeName ||
          item.name === '' ||
          item.typeName === ''
        ) {
          this.sendCustomNotification(
            'Json file import error',
            'Missing name or typeName in the ' +
              indexOfParentObject +
              ' parent Object'
          )
          return
        }
        if (!item.updatedAt || item.updatedAt === '') {
          this.sendCustomNotification(
            'Json file import error',
            'Missing updateAt in the ' + indexOfParentObject + ' parent Object'
          )
          return
        }
        for (let subItemName in item) {
          if (
            typeof item[subItemName] === 'object' &&
            subItemName !== 'parametricValues' &&
            subItemName !== 'parametricReferences'
          ) {
            if (item[subItemName].id !== null) {
              item[subItemName].id = ''
            }
            if (
              !item[subItemName].name ||
              !item[subItemName].typeName ||
              item[subItemName].name === '' ||
              item[subItemName].typeName === ''
            ) {
              this.sendCustomNotification(
                'Json file import error',
                'Missing name or typeName in ' + item.name + ' - ' + subItemName
              )
              return
            }
            if (
              !item[subItemName].updatedAt ||
              item[subItemName].updatedAt === ''
            ) {
              this.sendCustomNotification(
                'Json file import error',
                'Missing updateAt in the ' + item.name + ' - ' + subItemName
              )
              return
            }
          }
        }
        indexOfParentObject++
        await this.$http
          .post(
            `${this.root.root.getCurrentAPI()}/createrecursiveindatabase`,
            item
          )
          .then(() => {
            this.root.root.refreshTable()
          })
          .catch((e) => {
            this.root.root.displayMessage(
              'Json parse error.',
              "Data isn't supported.",
              'notification',
              'error'
            )
          })
      }
      this.closeImportExportJsonFileDialog()
    },
    importItems() {
      let formData = new FormData()
      formData.append('jsonFile', this.file)
      let headers = { headers: { 'Content-Type': 'multipart/form-data' } }
      this.$http
        .post(
          `${this.root.root.getCurrentAPI()}/convertjsonfile`,
          formData,
          headers
        )
        .then((response) => {
          this.formatDataToImport(response.data)
        })
        .catch((error) => {
          this.root.root.displayMessage(
            'Json parse error.',
            error,
            'notification',
            'error'
          )
        })
      this.closeImportExportJsonFileDialog()
    }
  }
}
</script>
